// extracted by mini-css-extract-plugin
export default {"item":"Item_item__S9H7-","icon":"Item_icon__2Eyim","subtitle":"Item_subtitle__vUkcb","tooltip":"Item_tooltip__bB4ps","counter":"Item_counter__0K1wG","balance":"Item_balance__9IqP-"};